import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library.
 *
 * Trailing `_` on `eligibility-list_` opts this route out of the parent
 * `eligibility-list` layout (which otherwise renders the list view). The
 * visible URL remains `/schedule/eligibility-list/payer-connection-dashboard`.
 */
export const Route = createFileRoute('/schedule/eligibility-list_/payer-connection-dashboard')({});
